// extracted by mini-css-extract-plugin
module.exports = {"svgContainer":"_51CZCCz0Sq5IQ4qnRjbLJ","flyUp":"_3F8f6wnImLvRgEHSwxxz-M","flyUpKeyFrame":"_1x7yvZ5QeaxOPW3ZY38huV"};